import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '@/styles/swiper.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';


interface SliderProps {
  images: string[];
}

const Slider: React.FC<SliderProps> = ({images}) => {
  const swiperRef = useRef<any>(null);

  return (
    <div className='relative w-full max-w-lg mx-auto'>
      <button
        onClick={() => swiperRef.current?.slidePrev()}
        className='h-[45px] w-[45px] absolute top-1/2 left-[-22px] transform -trandark-y-1/2 bg-gray-800 text-white rounded-full z-50'
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <button
        onClick={() => swiperRef.current?.slideNext()}
        className='h-[45px] w-[45px] absolute top-1/2 right-[-22px] transform -trandark-y-1/2 bg-gray-800 text-white rounded-full z-50'
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>

      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        navigation={false} // Disable default navigation as we're using custom buttons
        modules={[Navigation]}
        loop={true}
        spaceBetween={50}
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <Image
              src={src}
              alt={`Slide ${index + 1}`}
              width={600} // Specify the image width
              height={300} // Specify the image height
              className='w-full h-auto rounded-lg'
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;